const DEFAULT_REDIRECT = '/login'

type LogoutOptions = {
  redirectPath?: string;
}

export const logout = ({ redirectPath = DEFAULT_REDIRECT }: LogoutOptions = {}) => {
  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch (error) {
    console.warn('Failed to clear browser storage during logout', error);
  }

  window.location.href = redirectPath;
};
